
import EchartMap from './EchartMap';
export default EchartMap;
